import { gsap } from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";

import './purpose-counter.scss';
gsap.registerPlugin(ScrollTrigger);


const counters = {
    count1: 0,
    cw2: 0,
    cw3: 0,
    cw1: undefined
}


// dynamic year count
const currentYear = new Date().getFullYear();
const activeYears = currentYear - 1965;


const tl1 = gsap.timeline({
    scrollTrigger: "#purpose-counter",
    once: false,
    start: "top bottom"
})

    .to(counters, {
        duration: 4,
        cw1: activeYears,
        snap: 1,
        onUpdate: function () {
            document.getElementById('count1').innerHTML = Math.ceil(counters.cw1);
        },
    })




